<template>
	<div style="max-width: 500px;margin: 0 auto;">
		<Fontnavbar title="动态"/>
		<van-field
			v-model="username"
			name="username"
			label="用户名"
			placeholder="请输入用户名"
		/>
		<van-field
			v-model="password"
			type="password"
			name="password"
			label="密码"
			placeholder="请输入密码"
		/>
		
		<div class="login-btn">
			<van-button round block type="danger"  @click="doLigin">
				立即登录
			</van-button>
		</div>
	</div>
</template>

<script>
import { dynamicLogin } from '../../../api.js'
import { post } from '../../../request.js'
import { Button, Field, Toast } from 'vant'
import Fontnavbar from "../../../components/Navbar.vue";
export default {
  components: {
    [Button.name]: Button,
		[Field.name]: Field,
		Fontnavbar
  },
	data() {
		return {
			username: '',
			password: '',
		};
	},
	
	methods: {
		doLigin() {
			if (this.username == '') {
				Toast('用户名不能为空')
				return false
			}
			if (this.password == '') {
				Toast('密码不能为空')
				return false
			}
			var that = this
			post(dynamicLogin, { 'user_name': that.username, 'password': that.password }).then((res) => { 
					if (res.code == 200) {
						that.$router.replace({ path: "/dynamic/admin/index" });
					} else {
						Toast(res.msg)
					}
			})
		}
	},
	
};

</script>

<style lang="less" scoped>
.login-btn{
	margin: 15px;
}
.login-tip{
	margin:15px 15px 0;
	font-size: 14px;
	color:#f00;
	text-align: right;
}
.login-tip span{
	margin:0px 5px;
}
</style>
